// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-item__title{\n  font-size:16px;\n  font-weight:700;\n  color:#495d7b;\n  margin-bottom:8px\n}\n.input-item__error,.input-item__title{\n  font-family:\"Open Sans\";\n  line-height:1.2em\n}\n.input-item__error{\n  font-size:11px;\n  color:#f34857;\n  margin-top:5px\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
